// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import NewsletterSignup from "@dip/helsecore/src/components/parts/NewsletterSignup/NewsletterSignup";
import type { NewsletterSignupProps } from '@dip/helsecore/src/components/parts/NewsletterSignup/NewsletterSignup.d';

export default (props: Readonly<NewsletterSignupProps>) => <NewsletterSignup {...props} />
